import { SkeletonLoader } from '@kanda-libs/ks-design-library';

interface ViewComponentProps {
  /**
   * Kanda job object
   */
  logo?: string;
  /**
   * Kanda job object
   */
  name?: string;
  /**
   * Kanda job object
   */
  isLoading?: boolean;
}

const ViewComponent = ({ logo, name, isLoading }: ViewComponentProps) => (
  <SkeletonLoader
    width={120}
    height={80}
    isLoading={isLoading}
    wrapperClassName="mb-10 hidden md:block"
    afterLoading={
      logo && (
        <div className="hidden md:block h-20 w-30 mb-10">
          <img src={logo} alt={name} className="max-w-full max-h-full" />
        </div>
      )
    }
  />
);

ViewComponent.displayName = 'JobSidebar-Header-view';

ViewComponent.defaultProps = {
  logo: undefined,
  name: undefined,
  isLoading: false,
};

export default ViewComponent;
